module.exports = __webpack_public_path__ + "static/media/error.87a47ef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/error.svg
// module id = 2290
// module chunks = 0